/***************************************************************************************/
// VARIABLE SETUP
/***************************************************************************************/
var time = 0;
var answerScore = null;
var answerClicked = null;
var timer = null;
var currentSlide = 1;